import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import {useSettingsStore} from "@/api/store/settings"
import {inject, onMounted, reactive, ref, watch} from "vue";
import {useUserStore} from "@/api/store/user";
import EmergencyContact from "@/views/ClientComponents/PersonalDetails/EmergencyContact.vue";
import ProfileDetails from "@/views/ClientComponents/PersonalDetails/ProfileDetails.vue";
import PrimaryAddress from "@/views/ClientComponents/PersonalDetails/PrimaryAddress.vue";
import ShippingAddress from "@/views/ClientComponents/PersonalDetails/ShippingAddress.vue";
import {appService} from "@/api/services/app";
import {setUser} from "@/api/services/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalDetails',
  setup(__props) {

const snackBarPlugin = inject('snackbar');

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const state = reactive({
  profileForm: {
    edit: false,
  },
  emergencyContact: {
    edit: false,
  },
  primaryAddress: {
    edit: false,
  },
  shippingAddress: {
    edit: false,
  },
});

const addressMatch = ref(userStore.user.address_match)
let stateBackup = JSON.parse(JSON.stringify(userStore.user))

const onClose = (key) => {
  userStore.user = JSON.parse(JSON.stringify(stateBackup))
  state[key].edit = false
}

const onEdit = (key) => {
  stateBackup = JSON.parse(JSON.stringify(userStore.user))
  state[key].edit = true
}

const save = (data: any) => {
  state.profileForm.edit = false;

  userStore.update(data).then(() => {
    snackBarPlugin.successSnackbar('Profile updated successfully');
  }).catch(error => {
    console.error('Failed to update profile:', error);
    snackBarPlugin.errorSnackbar('Failed to update profile');
  });
}
const saveEmergency = (data) => {
  state.emergencyContact.edit = false
  userStore.updateEmergency(data).then(() => {
    snackBarPlugin.successSnackbar('Emergency contact updated successfully');
  }).catch(error => {
    console.error('Failed to update emergency contact:', error);
    snackBarPlugin.errorSnackbar('Failed to update emergency contact');
  });
}
const savePrimaryAddress = (data) => {
  state.primaryAddress.edit = false

  userStore.updatePrimary(data).then((response) => {
    snackBarPlugin.successSnackbar('Primary address updated successfully');

    if (addressMatch.value == true) {
      const shippingAddress = {
        ...response.data,
        id: getAddress('shipping').id,
        type: 'shipping',
        address_match: true
      };
      userStore.updateShipping(shippingAddress);
    }
  }).catch(error => {
    console.error('Failed to update primary address:', error);
    snackBarPlugin.errorSnackbar('Failed to update primary address');
  });
}
const saveShippingAddress = (data) => {
  state.shippingAddress.edit = false
  const shippingAddress = {...data, address_match: false};

  userStore.updateShipping(shippingAddress).then(() => {
    snackBarPlugin.successSnackbar('Shipping address updated successfully');
  }).catch(error => {
    console.error('Failed to update shipping address:', error);
    snackBarPlugin.errorSnackbar('Failed to update shipping address');
  });
}

// Get the address of the shipping or primary address type 
const getAddress = (type = 'primary') => {
  return userStore.user?.addresses.find(address => address.type === type)
}

const fetchData = () => {
  appService.fetchDisplay().then((response: any) => {
    userStore.setUser(response.client);
    setUser(response.client);
  })
}

const toggleAddressMatch = () => {
  if (addressMatch.value == false) {
    const primaryAddress = {
      ...getAddress('primary'),
      id: getAddress('shipping').id,
      type: 'shipping',
      address_match: true
    };
    userStore.updateShipping(primaryAddress);
  }
}

onMounted(() => {
  fetchData();
})

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"background-color":"#F5F5F5"} }, {
    default: _withCtx(() => [
      (!state.emergencyContact.edit && !state.primaryAddress.edit && !state.shippingAddress.edit)
        ? (_openBlock(), _createBlock(ProfileDetails, {
            key: 0,
            "button-color": _unref(settingsStore).settings.buttonColor,
            color: _unref(settingsStore).settings.primaryColor,
            data: _unref(userStore).user,
            edit: state.profileForm.edit,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (onClose('profileForm'))),
            onEdit: _cache[1] || (_cache[1] = ($event: any) => (onEdit('profileForm'))),
            onSave: save
          }, null, 8, ["button-color", "color", "data", "edit"]))
        : _createCommentVNode("", true),
      (!state.profileForm.edit && !state.primaryAddress.edit && !state.shippingAddress.edit)
        ? (_openBlock(), _createBlock(EmergencyContact, {
            key: 1,
            "button-color": _unref(settingsStore).settings.buttonColor,
            color: _unref(settingsStore).settings.primaryColor,
            data: _unref(userStore).user.emergency_contact,
            edit: state.emergencyContact.edit,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose('emergencyContact'))),
            onEdit: _cache[3] || (_cache[3] = ($event: any) => (onEdit('emergencyContact'))),
            onSave: saveEmergency
          }, null, 8, ["button-color", "color", "data", "edit"]))
        : _createCommentVNode("", true),
      (!state.profileForm.edit && !state.emergencyContact.edit && !state.shippingAddress.edit)
        ? (_openBlock(), _createBlock(PrimaryAddress, {
            key: 2,
            "button-color": _unref(settingsStore).settings.buttonColor,
            color: _unref(settingsStore).settings.primaryColor,
            data: getAddress('primary'),
            edit: state.primaryAddress.edit,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (onClose('primaryAddress'))),
            onEdit: _cache[5] || (_cache[5] = ($event: any) => (onEdit('primaryAddress'))),
            onSave: savePrimaryAddress
          }, null, 8, ["button-color", "color", "data", "edit"]))
        : _createCommentVNode("", true),
      (!state.profileForm.edit && !state.emergencyContact.edit && !state.primaryAddress.edit && !state.shippingAddress.edit)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 3,
            class: "px-1 pt-1 pb-1 b-round-20 switch-right",
            onClick: toggleAddressMatch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: addressMatch.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addressMatch).value = $event)),
                color: _unref(settingsStore).settings.primaryColor,
                "false-value": 0,
                "true-value": 1,
                class: "switch-right font-size-10-400",
                label: "Same as Shipping Address"
              }, null, 8, ["modelValue", "color"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!state.profileForm.edit && !state.emergencyContact.edit && !state.primaryAddress.edit && !addressMatch.value)
        ? (_openBlock(), _createBlock(ShippingAddress, {
            key: 4,
            "button-color": _unref(settingsStore).settings.buttonColor,
            color: _unref(settingsStore).settings.primaryColor,
            data: getAddress('shipping'),
            edit: state.shippingAddress.edit,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (onClose('shippingAddress'))),
            onEdit: _cache[8] || (_cache[8] = ($event: any) => (onEdit('shippingAddress'))),
            onSave: saveShippingAddress
          }, null, 8, ["button-color", "color", "data", "edit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})